import { createAction, props } from '@ngrx/store';

export const LoyaltyProgramsRequest = createAction('[Loyalty Programs] Request  programs');

export const LoyaltyProgramsSuccessRequest = createAction('[Loyalty Programs] Success request  programs', props<{ payload: OLO.DTO.LoyaltyProgramAppAssignmentModel[] }>());

export const LoyaltyProgramsErrorRequest = createAction('[Loyalty Programs] Error request  programs', props<{ ex?: any }>());

export const LoyaltyProgramsReset = createAction('[Loyalty Programs] Reset');
